import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-accounts',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './accounts.component.html',
  styleUrl: './accounts.component.css'
})
export class AccountsComponent implements OnInit, OnDestroy {
  groupedAccounts: any = {};
  isLoading: boolean = true;
  private firmSubscription: Subscription | null = null;
  currentFirmId: number | null = null;

  constructor(
    private accountService: AccountService,
    private firmSelectionService: FirmSelectionService
  ) { }

  ngOnInit(): void {
    // Subscribe to firm selection changes
    this.firmSubscription = this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      this.currentFirmId = firm ? firm.id : null;
      this.fetchGroupedAccounts();
    });
  }

  ngOnDestroy(): void {
    if (this.firmSubscription) {
      this.firmSubscription.unsubscribe();
    }
  }

  fetchGroupedAccounts(): void {
    this.isLoading = true;
    const params = this.currentFirmId ? { firm_id: this.currentFirmId } : {};
    this.accountService.getGroupedAccounts(params).subscribe({
      next: (res: any) => {
        this.groupedAccounts = res.data || {};
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching accounts:', err);
        this.isLoading = false;
      }
    });
  }

  // Get all accounts under a primary and group (or groups) flattened into a single list
  getAccountsByGroup(primary: string, groupOrGroups: string | string[]): any[] {
    const groups = Array.isArray(groupOrGroups) ? groupOrGroups : [groupOrGroups];

    if (!this.groupedAccounts[primary]) {
      // Fallback for primary name mismatches (e.g. Equality vs Equity)
      if (primary === 'Equity' && this.groupedAccounts['Equality']) primary = 'Equality';
      else if (primary === 'Equality' && this.groupedAccounts['Equity']) primary = 'Equity';
      else return [];
    }

    const accounts: any[] = [];
    groups.forEach(group => {
      if (this.groupedAccounts[primary][group]) {
        Object.keys(this.groupedAccounts[primary][group]).forEach(main => {
          accounts.push(...this.groupedAccounts[primary][group][main]);
        });
      }
    });
    return accounts;
  }

  // Get a specific chunk of an array to distribute across columns
  getChunk(arr: any[], chunkIndex: number, totalChunks: number): any[] {
    if (!arr || arr.length === 0) return [];
    const chunkSize = Math.ceil(arr.length / totalChunks);
    const start = chunkIndex * chunkSize;
    const end = start + chunkSize;
    return arr.slice(start, end);
  }

  // Get keys of an object for iteration
  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }
}
